import { PasswordValues } from "../components/PasswordInput/PasswordInput"
import { FileUpload } from "./file"

export interface ProfileValues {
    firstName: string
    lastName: string
    phoneNumber?: string
    email: string
    language: string
    translateLanguage: string
    maxCapacity: number
    password?: PasswordValues
    uploadedPicture?: FileUpload<Blob>
    keyCombination?: string
    TranslateLocale?: string
}

export enum SendKeyCombinations {
    Enter = "Enter",
    CtrlEnter = "Ctrl+Enter",
    ShiftEnter = "Shift+Enter"
}
